import { excludeHiddenPeriods } from 'app/const/hiddenPeriods';

/**
 * Страницы promo-checkout, на которых скрытые недели остаются доступными
 */
export const HIDDEN_PERIODS_EXCLUDED_PAGE_IDS = ['halloween', 'halloweentefal'];

/**
 * @description убирает скрытые недели из списка периодов, кроме страниц-исключений
 */
export const filterHiddenPeriods = (periods, pageId) => {
    const visiblePeriods = periods || [];

    if (HIDDEN_PERIODS_EXCLUDED_PAGE_IDS.includes(pageId)) {
        return visiblePeriods;
    }

    return excludeHiddenPeriods(visiblePeriods);
};
